import React, { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import InputField from "../../Components/InputField/InputField";
import noImage from "../../Assests/avatar1.png";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";
import { deleteCatageory, postCatageory } from "../../api";
import CatageorySVG from "../../Components/SVGS/CatageorySVG";

function AddRole({ isEdit, isDelete }) {
  const icon = () => {
    return <CatageorySVG size="26" fill="#DF2F35" />;
  };

  const location = useLocation();
  const catageoryEdit =
    location.state && location.state ? location.state.catageoryToEdit : null;
  const page =
    location.state && location.state ? location.state.currentPage : null;

  let baseUrl = process.env.REACT_APP_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [editImage, setEditImage] = useState("");
  const [imageErr, setImageErr] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [err, setErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [imageInputError, setImageInputError] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [catageory, setCatageory] = useState({
    id: catageoryEdit !== null ? catageoryEdit.id : 0,
    name: catageoryEdit ? catageoryEdit.name : "",
    image_path: catageoryEdit ? catageoryEdit.image_path : "",
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setEditImage(catageoryEdit ? catageoryEdit.image_path : "");
  }, []);

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  const navigate = useNavigate();

  const saveOnclick = () => {
    if (catageory.name === "") setNameErr(true);
    // else if (editImage === "" && profileImage === "") {
    //   setNameErr(false);
    //   setImageInputError(true);
    // }
    else {
      setNameErr(false);
      setImageInputError(false);
      setErr(false);
      setIsLoading(true);
      let catageoryData = new FormData();
      catageoryData.append("id", catageory.id);
      catageoryData.append("name", catageory.name);
      if (typeof profileImage == "string")
        catageoryData.append("image_path", editImage);
      else catageoryData.append("image", profileImage, profileImage.name);
      postCatageory(catageoryData)
        .then(({ data }) => {
          setIsLoading(false);
          if (data.success)
            navigate("/dashboard/newsEventCatageory", {
              state: { page: page },
            });
          else {
            setErr(true);
            setErrMsg(data.message);
          }
        })
        .catch((err) => {
          console.log("client add Error: ", err);
          setErr(true);
          setIsLoading(false);
          if (err.message === "Request failed with status code 400")
            setErrMsg("All Fields Required. Id Error!");
          else setErrMsg(err.message);
        });
    }
  };

  const delOnclick = () => {
    setModalIsOpen(true);
  };

  const deleteClick = () => {
    let obj = {
      id: catageoryEdit ? catageoryEdit.id : null,
    };
    setIsLoading(true);
    deleteCatageory(obj)
      .then(({ data }) => {
        setIsLoading(false);
        setModalIsOpen(false);
        if (data.success) {
          navigate("/dashboard/newsEventCatageory", { state: { page: page } });
        } else {
          setErr(true);
          setErrMsg(data.message);
        }
      })
      .catch((err) => {
        console.log("delete catageory axios error", err);
        setErr(true);
        setModalIsOpen(false);
        setIsLoading(false);
      });
  };

  const onSelectImage = (img) => {
    if (
      img.type.includes("png") ||
      img.type.includes("jpg") ||
      img.type.includes("jpeg")
    ) {
      setProfileImage(img);
      setImageErr(false);
      setEditImage("");
    } else {
      alert("Invalid File!");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCatageory({ ...catageory, [name]: value });
  };

  const handleImageErr = () => {
    setImageErr(true);
  };

  console.log("eii", editImage);
  console.log("pp", profileImage);

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setModalIsOpen(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            <>
              <h3 style={{ color: "white", marginBottom: "60px" }}>
                Are you sure you want to delete?
              </h3>

              <Gbtn
                text="Delete"
                color="#EE282E"
                radius="6px"
                width="40%"
                func={deleteClick}
              />
            </>
          </>
        )}
      </Modal>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText={"News & Events Catageory"} />
        </div>
        <div className="dashPanel" style={{ position: "relative" }}>
          <>
            <div className="ar-dashpanel">
              <h4
                style={{
                  display: err ? "flex" : "none",
                  justifyContent: "center",
                  color: "red",
                  position: "absolute",
                  top: "0",
                  width: "90%",
                }}
              >
                <p>Error! {errMsg}.</p>
              </h4>
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <LoadingSpinner />
                </div>
              ) : (
                <div>
                  <div>
                    <div className="ae-formFields">
                      <div className="ae-inputField">
                        <InputField
                          isErr={nameErr}
                          errorMsg="Name is required."
                          name={"name"}
                          value={catageoryEdit ? catageoryEdit.name : null}
                          onChange={(e) => {
                            setNameErr(false);
                            handleChange(e);
                          }}
                          placeholder={"Name"}
                          radius="5px"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="if-txt" style={{ marginTop: "40px" }}>
                    Add Image
                  </div>
                  {/* <div className="Add_Client_Image_container">
                    <label className="changeimage-label">
                      {editImage || profileImage ? (
                        <>
                          <img
                            src={
                              editImage
                                ? baseUrl + editImage
                                : URL.createObjectURL(profileImage)
                            }
                            onError={handleImageErr}
                            alt="cp"
                            height="120px"
                            width="120px"
                            className="add-image-Style"
                          />
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => {
                                setImageInputError(false);
                                onSelectImage(e.target.files[0]);
                              }}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <div className="AddimageBtn">
                          <span className="cam_Image_upload">+</span>
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => {
                                setImageInputError(false);
                                onSelectImage(e.target.files[0]);
                              }}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </label>
                  </div> */}
                  <div className="Add_Client_Image_container">
                    <label className="changeimage-label">
                      {editImage || profileImage ? (
                        <>
                          <img
                            src={
                              editImage
                                ? baseUrl + editImage
                                : URL.createObjectURL(profileImage)
                            }
                            onError={handleImageErr}
                            alt="cp"
                            height="120px"
                            width="120px"
                            className="add-image-Style"
                          />
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => onSelectImage(e.target.files[0])}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <div className="AddimageBtn">
                          <span className="cam_Image_upload">+</span>
                          <div>
                            <input
                              type="file"
                              className="formuploadimage_input"
                              accept=".png, .jpg, jpeg"
                              onChange={(e) => onSelectImage(e.target.files[0])}
                              onClick={(event) =>
                                (event.currentTarget.value = null)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </label>
                  </div>
                  <div
                    className="err-txt"
                    style={{
                      display: imageInputError ? "flex" : "none",
                      width: "150px",
                    }}
                  >
                    image is required
                  </div>
                </div>
              )}
              <div className="addEdit-btns">
                <div className="ev-btnAdd ev-btn">
                  <Gbtn
                    text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                    func={isDelete ? delOnclick : saveOnclick}
                    disabled={isLoading}
                    color="#DF2F35"
                    radius="5px"
                    width="150px"
                  />
                </div>
                <div className="ev-btnDel ev-btn">
                  <Gbtn
                    text={isDelete ? "Back" : "Discard"}
                    color="#0061B1"
                    func={() =>
                      navigate("/dashboard/newsEventCatageory", {
                        state: { page: page },
                      })
                    }
                    radius="5px"
                    width="150px"
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
}

export default AddRole;
